import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Filter from "../components/Filter";
import fleetIdsSelector from "../selectors/fleetIdsSelector";
import { updateFilterState } from "../actions/filter";

class FilterContainer extends Component {
  render() {
    return (
      <Filter
        fleetIds={this.props.fleetIds}
        selectedFleetIds={this.props.selectedFleetIds}
        fleetsCount={this.props.fleetsCount}
        visitsCount={this.props.visitsCount}
        updateFilterState={this.props.updateFilterState}
        showSideBar={this.props.showSideBar}
      />
    );
  }
}

FilterContainer.propTypes = {
  fleetsCount: PropTypes.number.isRequired,
  visitsCount: PropTypes.number.isRequired,
  fleetIds: PropTypes.array.isRequired,
  selectedFleetIds: PropTypes.array.isRequired,
  updateFilterState: PropTypes.func.isRequired,
  showSideBar: PropTypes.bool,
};

function mapStateToProps(state) {
  const { jobReducer, filterReducer, settingsReducer } = state;

  return {
    fleetIds: fleetIdsSelector(state),
    selectedFleetIds: filterReducer.fleetIds,
    fleetsCount: jobReducer.fleetsCount,
    visitsCount: jobReducer.visitsCount,
    showSideBar: settingsReducer.showSideBar && !filterReducer.keyword,
  };
}

export default connect(mapStateToProps, { updateFilterState })(FilterContainer);
